import { Box, HeadingProps, useStyleConfig } from "@chakra-ui/react";

export function Heading(props: HeadingProps) {
  const { variant, ...rest } = props;
  const styles = useStyleConfig("heading", props);

  // Pass the computed styles into the `__css` prop
  return <Box __css={styles} {...rest} />;
}
